export default __webpack_public_path__ + "static/media/google.0414d84e.png";